var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"rose-chart"}},[_c('module-title',{attrs:{"title":"今日支付方式占比"}}),_c('div',{staticStyle:{"width":"100%","height":"70%"},attrs:{"id":"paywayChart"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }